'use client'

import { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'

const VIDEO_PLAYER_CONFIG = {
  youtube: {
    playerVars: {
      controls: 0,
      showinfo: 0,
      modestbranding: 1,
      rel: 0,
      autoplay: 1,
    },
  },
}

interface VideoPlayerProps {
  url: string
  thumbnail: string | null
}

export const VideoPlayer = ({ url, thumbnail }: VideoPlayerProps) => {
  const [isClient, setIsClient] = useState(false)

  useEffect(() => {
    setIsClient(true)
  }, [])

  return isClient ? (
    <div className="aspect-[1/0.5625] w-full bg-gray-400">
      <ReactPlayer
        url={url}
        loop
        controls
        light={thumbnail ?? thumbnail ?? true}
        width="100%"
        height="100%"
        playing
        playIcon={
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none">
            <circle cx="60" cy="60" r="60" fill="white" />
            <path d="M54 72V48L73 60L54 72Z" fill="#272727" />
          </svg>
        }
        config={VIDEO_PLAYER_CONFIG}
      />
    </div>
  ) : (
    <div />
  )
}
